import styled from 'styled-components';
import { FONTS, SIZE, COLORS } from '@app/src/ui';
import { Assesors } from '../Assesors';
import { Security } from '../Security';

interface Props {
  isDisplay?: boolean;
}

export const Weight = styled.span`
  font-weight: 600;
`;

export const Subtitle = styled.h3`
  font-family: ${FONTS.OPEN_SANS};
  font-size: 13px;
  line-height: 15px;
  margin-bottom: 10px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 16px;
  }
`;

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

export const Wrapper = styled.footer`
  display: ${(props:Props) => props.isDisplay ? 'block' : 'none'};
  font-family: ${FONTS.OPEN_SANS};
  background: #000;
  color: #fff;
  font-size: 12px;
  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 12px;
    ${Container} {
      display: flex;
      padding: 24px 15px 30px;
      justify-content: space-between;
      align-items: flex-start;
    }
  }
  @media (min-width: ${SIZE.LARGE_DESKTOP}) {
    ${Container} {
      padding: 15px 0;
    }
  }
`;

export const SecurityWrapper = styled(Security)`
  padding: 15px 0 16px;
  width: 100%;
  min-width: 200px;
  text-align: center;
  a:nth-child(4) {
    margin-left: 2px;
  }
  img {
    width: 55px;
    height: 34px;
  }
  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    text-align: left;
    padding: 0;
    width: auto;
  }
  @media (min-width: ${SIZE.TABLET_BREAK}) {
    text-align: left;
    font-size: 16px;
    line-height: 18px;
    font-weight: 600;
    a:nth-child(4) {
      margin-left: 8px;
    }
    img {
      width: 65px;
      height: 40px;
    }
  }
`;  

export const Legacy = styled.div`
  padding: 0 15px;
  margin-top: 30px;
  text-align: center;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    margin: 0;
    padding: 0;
  }

  @media (min-width: ${SIZE.TABLET_BREAK}) {
    min-width: 154px;
    text-align: left;
    padding-left: 32px;
    border-left: 1px solid #222222;
  }
`;

export const Social = styled.div`
  padding: 15px 0 0;
  text-align: center;
  background: #000;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    width: auto;
    padding: 0;
    display: block;
    text-align: left;
  }
`;

export const Network = styled.div`
  display: flex;
  justify-content: center;
  a {
    color: #fff;
  }
  a:not(:first-child){
    margin-left: 6px;

  }
`;

export const TermsAndConditions = styled.ul`
  position: relative;
  margin: 0 auto;
  svg {
    position: absolute;
    left: -50px;
  }
  li {
    margin: 0 0 4px;
  }
  a {
    color: ${COLORS.GRAY_PLACEHOLDER};
    font-size: 13px;
    &:hover {
      text-decoration: underline;
    }
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    svg {
      display: none;
    }
  }

  @media (min-width: ${SIZE.TABLET_BREAK}) {
    svg {
      display: block;
    }
  }
`;

export const AssesorsWrapper = styled(Assesors)`
  padding: 15px 0;
  width: 100%;
  text-align: center;
  h3 {
    color: #fff;
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    text-align: left;
  }
`;

export const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #222;
  border-radius: 100%;
  width: 36px;
  height: 36px;
`;

export const CentralHelp = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CentralHelpSubtitle = styled.h3`
  font-size: 16px;
  margin: 0 auto 4px;
`;

export const BookLink = styled.a`
  display: inline-block;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    margin-bottom: 24px;
  }
`;